import { render, staticRenderFns } from "./cms_view.vue?vue&type=template&id=37cf22a7&"
import script from "./cms_view.vue?vue&type=script&lang=js&"
export * from "./cms_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports